<template>
    <div class="MemberManagement">
        <div class="header">
            <el-button type="primary" style="margin: 0 0 20px;" @click="Clickexport">导出数据</el-button>
            <br/>
            <el-row style="line-height:40px;">
                <el-col :span="1">综合查询</el-col>
                <el-col :span="4">
                    <el-input v-model="params.searchValue" placeholder="会员手机号、姓名" clearable ></el-input>
                </el-col>
                <el-col :span="1" style="margin-left: 20px;">会员等级</el-col>
                <el-col :span="4">
                    <el-select v-model="params.memberLevel" clearable placeholder="请选择" style="width:100%;">
                        <el-option v-for="item in memberLevellist" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="1" style="margin-left: 20px;">会员状态</el-col>
                <el-col :span="4">
                    <el-select v-model="params.memberStatus" clearable placeholder="请选择" style="width:100%;">
                        <el-option v-for="item in memberStatuslist" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="1"  style="margin-left: 20px;">会员生日</el-col>
                <el-col :span="4">
                    <el-select v-model="params.memberBirthday" clearable placeholder="请选择" style="width:100%;">
                        <el-option v-for="item in memberBirthdaylist" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row style="line-height: 40px;margin-top:20px;">
                <el-col :span="1">到期时间</el-col>
                <el-col :span="6">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="expiretime"    
                        type="daterange"
                        range-separator="至"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="changeexpire"
                        >
                    </el-date-picker>
                </el-col>
                <el-col :span="1" style="margin-left: 20px;">添加时间</el-col>
                <el-col :span="6">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="addtime"    
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="changeadd">
                    </el-date-picker>
                </el-col>
                <el-col :span="6" style="margin-left: 20px;">
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="react">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="management">
            <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="memberData"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange">
                <el-table-column type="selection"> </el-table-column>
                <el-table-column prop="userId" label="账号"></el-table-column>
                <el-table-column prop="realName" label="姓名"></el-table-column>
                <el-table-column prop="birthday" label="生日"></el-table-column>
                <el-table-column prop="phone" label="手机号"></el-table-column>
                <el-table-column prop="memberLevelStr" label="会员等级"></el-table-column>
                <el-table-column prop="addTime" label="添加时间"></el-table-column>
                <el-table-column prop="expirationTime" label="到期时间"></el-table-column>
                <el-table-column prop="memberStatusStr" label="会员状态"></el-table-column>
                <el-table-column prop="rechargeAmount" label="充值金额(元)"></el-table-column>
                <el-table-column prop="balance" label="余额(元)"></el-table-column>
                <el-table-column prop="consumptionAmount" label="消费金额(元)"></el-table-column>
                <el-table-column prop="consultationNum" label="咨询次数"></el-table-column>
                <el-table-column prop="integral" label="积分"></el-table-column>
                <el-table-column label="操作">
                    <template v-slot="scope">
                        <el-button type="text" style="margin-right: 5px;" @click="ClickDetail(scope.row)">详情</el-button>
                        <el-popconfirm
                        @confirm="confirmfreeze(scope.row)"
                        :title="scope.row.memberStatusStr=='已冻结'?'确认解冻该条记录吗？':'确认冻结该条记录吗？'"
                        >
                            <el-button type="text" slot="reference">{{scope.row.memberStatusStr=='已冻结'?'解冻':'冻结'}}</el-button>
                        </el-popconfirm>
                        
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum"
                :page-size="params.pageSize"
                hide-on-single-page
                layout="total, prev, pager, next"
                :total="params.Total">
            </el-pagination>

        </div>

        <!-- 详情弹窗 -->
        <el-drawer
            :visible.sync="drawerDetail"
            size="40%"
            :with-header="false">
            <el-form class="drawerDetail">
                <el-form-item label="会员账号：" label-width="90px"><el-input v-model="memberDetailData.userId" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="充值金额：" label-width="90px"><el-input v-model="memberDetailData.rechargeAmount" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="会员余额：" label-width="90px"><el-input v-model="memberDetailData.balance" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="消费金额：" label-width="90px"><el-input v-model="memberDetailData.consumptionAmount" disabled clearable style="width: auto;"></el-input></el-form-item>
                <el-form-item label="添加时间：" label-width="90px"><el-date-picker v-model="memberDetailData.addTime" type="date" disabled></el-date-picker></el-form-item>
                <el-form-item label="到期时间：" label-width="90px"><el-date-picker v-model="memberDetailData.expirationTime" type="date" disabled></el-date-picker></el-form-item>
                <el-form-item label="会员等级：" label-width="90px"><el-input v-model="memberDetailData.memberLevelStr" disabled clearable style="width: auto;" maxlength="6"></el-input></el-form-item>
                <el-form-item label="会员姓名：" label-width="90px"><el-input v-model="memberDetailData.realName" clearable style="width: auto;" maxlength="6"></el-input></el-form-item>
                <el-form-item label="身份证号：" label-width="90px"><el-input v-model.number="memberDetailData.idCard" clearable style="width: auto;" maxlength="18"></el-input></el-form-item>
                <el-form-item label="手机号：" label-width="90px"><el-input v-model.number="memberDetailData.phone" clearable style="width: auto;" maxlength="11"></el-input></el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editinfo">确认</el-button>
                    <el-button @click="drawerDetail=false">返回</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>

    </div>
</template>
<script>
export default{
    name:'MemberManagement',
    data() {
        return {
            params:{
                pageNum:1,
                pageSize:10,
                pageTotal:0,
                searchValue:'',
                memberLevel:'',
                memberStatus:'',
                memberBirthday:'',
                startExpiration:'',
                endExpiration:'',
                startAddTime:'',
                endAddTime:''
            },
            drawerDetail:false,
            loading:false,
            expiretime:'',
            addtime:'',
            memberLevellist:[
                {name:'普通用户',value:'ordinary'},
                {name:'黄金会员',value:'gold'},
                {name:'白金会员',value:'platinum'},
                {name:'钻石会员',value:'diamond'},
            ],
            memberStatuslist:[
                {name:'未到期',value:'unexpired'},
                {name:'即将到期',value:'due'},
                {name:'最近新增',value:'recentlyAdded'},
                {name:'已过期',value:'expired'},
                {name:'已冻结',value:'frozen'}
            ],
            memberBirthdaylist:[
                {name:'今天',value:'today'},
                {name:'最近三天',value:'threeDays'},
                {name:'最近一周',value:'week'},
                {name:'最近两周',value:'twoWeeks'},
                {name:'最近一个月',value:'month'}
            ],
            memberData:[],
            memberDetailData:'',
        }
    },
    created() {
        this.memberlist()
    },
    methods: {
        memberlist(){
            this.loading=true;
            this.$Http_Post('kg/member/list',this.params).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.memberData=res.Data;
                    this.params.Total=res.Counts;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        handleSelectionChange(val){
            this.params.userIds=[];
            for(let item of val){
                this.params.userIds.push(item.userId);
            }
        },
        handleCurrentChange(val){
            this.params.pageNum=val;
            this.memberlist();
        },
        // 冻结
        confirmfreeze(val){
            if(val.memberStatusStr=='已冻结'){
                this.$Http_Post('kg/member/thaw',{userId:val.userId}).then(res=>{
                    if(res.Code==0){
                        this.$message({type: 'success', message:res.Message});
                        this.memberlist();
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                })
            }else{
                this.$Http_Post('kg/member/freeze',{userId:val.userId}).then(res=>{
                    if(res.Code==0){
                        this.$message({type: 'success', message:res.Message});
                        this.memberlist();
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                })
            }
            
        },
        changeexpire(val){
            if(val==null){
                this.params.startExpiration='';
                this.params.endExpiration='';
            }else{
                this.params.startExpiration=val[0];
                this.params.endExpiration=val[1];
            }
        },
        changeadd(val){
            if(val==null){
                this.params.startAddTime='';
                this.params.endAddTime='';
            }else{
                this.params.startAddTime=val[0];
                this.params.endAddTime=val[1];
            }
        },
        search(){
            this.params.pageNum=1;
            this.memberlist();
        },
        react(){
            this.params=this.$options.data().params;
            this.memberlist();
        },
        Clickexport(val){
            if(this.params.userIds){
                this.$Http_Post('kg/member/exportMemberList',this.params).then(res=>{
                    if(res.Code==0){
                        location.href=process.env.VUE_APP_URL + res.Message;
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                })
            }else{
                this.$message({type: 'warning',message:"请选择需要导出的数据"});
            }
        },
        // 打开详情
        ClickDetail(e){
            this.$Http_Post('kg/member/memberDetail',{userId:e.userId}).then(res=>{
                if(res.Code==0){
                    this.drawerDetail=true;
                    this.memberDetailData=res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
            this.memberDetailData=e;
        },
        editinfo(){
            this.$Http_Post('kg/member/editMember',this.memberDetailData).then(res=>{
                if(res.Code==0){
                    this.drawerDetail=false;
                    this.$message({type: 'success', message:res.Message});
                    this.memberlist();
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        }
    },
}
</script>
<style scoped>
.header{background: #fff;padding:20px;margin-bottom: 20px;}
.management{padding:20px;background: #fff;}
.drawerDetail{margin: 20px;}
.handle{padding:0 10px;color: #4e9cef;cursor: pointer;}
</style>